var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPRoadmapFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666687 0.500084H16.6154C16.8455 0.500084 17.0321 0.686634 17.0321 0.916751C17.0321 0.989259 17.0131 1.06052 16.9771 1.12348L14 6.33342L16.9771 11.5433C17.0913 11.7432 17.0219 11.9977 16.8221 12.1118C16.7591 12.1478 16.6879 12.1667 16.6154 12.1667H2.33335V16.3334H0.666687V0.500084Z",
    fill: "#868C98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPRoadmapFilled);
export default __webpack_public_path__ + "static/media/p-roadmap-filled.d3a009ce7f2cd2fde5f197bf08f4080b.svg";
export { ForwardRef as ReactComponent };